import React from 'react';
import CartLineItem from './CartLineItem';

const CartList = (props) => {
  const { data } = props;
  const { items, item_count } = data;

  if (item_count === 0) {
    return (
      <div className="loop" model="cart">
        <div className="empty-loop">
          You don't have any items in your cart. <a href="/">Continue shopping</a>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="loop" model="cart">
        {items.map((item, index) => {
          return <CartLineItem item={item} key={`${item.id}-${item.variant_id}-${index}`}></CartLineItem>;
        })}
      </div>
    </>
  );
};

export default CartList;
